/* Saucy offer: pack-count discounts + subscribe & save on the product page (with the 2-20 pack slider),
   quick-add buttons that always add the online minimum (2 six-packs), and the one-time / subscription
   cart switch used by the cart page.
   Subscription prices are per six-pack (rounded to the cent) x packs, matching how Checkout Champ charges.
   Settings come from snippets/sc-offer.liquid (Theme settings > Offer & subscriptions). */
(function () {
  'use strict';
  var OFFER = window.SaucyOffer || { min: 2, handles: ['bloom', 'soar', 'chill', 'variety-pack'], variants: [], tiers: [[4, 12], [3, 10], [2, 7]], subFirst: 25, sub: { '2w': 20, '1m': 15 }, cart: { packs: 0, mode: 'none', cadence: '' } };
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return '$' + (Math.round(cents) / 100).toFixed(2); };
  var off = function (cents, pct) { return Math.round(cents * (100 - pct) / 100); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function tierPct(packs) {
    for (var i = 0; i < OFFER.tiers.length; i++) if (packs >= OFFER.tiers[i][0]) return OFFER.tiers[i][1];
    return 0;
  }
  function cadenceLabel(c) { return c === '1m' ? 'every month' : 'every 2 weeks'; }

  /* A cart is either one-time or one subscription schedule, never both.
     Rebuilds the cart so every six-pack line matches mode/cadence, then adds `extra` items. */
  window.SaucySwitchCart = function (mode, cadence, extra) {
    var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items.map(function (it) {
          var props = {};
          Object.keys(it.properties || {}).forEach(function (k) { if (it.properties[k] != null) props[k] = it.properties[k]; });
          if (OFFER.handles.indexOf(it.handle) > -1) {
            delete props._subscription;
            if (mode === 'subscription') props._subscription = cadence || '2w';
          }
          return { id: it.variant_id, quantity: it.quantity, properties: props };
        }).concat(extra || []);
        return fetch(base + 'cart/clear.js', { method: 'POST', headers: json, body: '{}' })
          .then(function () {
            if (!items.length) return null;
            return fetch(base + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }) })
              .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
          });
      });
  };

  /* quick "add to cart" buttons (shop page, product cards): always add the online minimum
     (2 six-packs), and join the cart's subscription when the cart is already one */
  var cartInfo = OFFER.cart || { packs: 0, mode: 'none', cadence: '' };
  var need = Math.max(1, OFFER.min || 1);
  $$('form[action*="/cart/add"]').forEach(function (f) {
    if (f.hasAttribute('data-buybox')) return;
    var idIn = f.querySelector('[name="id"]');
    if (!idIn || (OFFER.variants || []).indexOf(parseInt(idIn.value, 10)) < 0) return;
    if (!f.querySelector('[name="quantity"]')) {
      var q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; q.value = need; f.appendChild(q);
    }
    if (cartInfo.mode === 'subscription' && !f.querySelector('[name="properties[_subscription]"]')) {
      var p = document.createElement('input'); p.type = 'hidden'; p.name = 'properties[_subscription]'; p.value = cartInfo.cadence || '2w'; f.appendChild(p);
    }
    var b = f.querySelector('button[type="submit"]:not([disabled])');
    if (b && need > 1 && /add to cart/.test(b.textContent)) b.textContent = b.textContent.replace('add to cart', 'add ' + need + ' six-packs');
  });

  /* product page buy box */
  $$('[data-buybox]').forEach(function (f) {
    var d = f.dataset, isOffer = d.offer !== 'false';
    var cartPacks = parseInt(d.cartPacks, 10) || 0, cartMode = d.cartMode || 'none', cartCad = d.cartCadence || '';
    var qty = $('[name="sc_qty"]', f), real = $('[data-real-qty]', f), prop = $('[data-sub-prop]', f);
    var subBox = $('[data-sub-options]', f), range = $('[data-pack-range]', f), hint = $('[data-tier-hint]', f), note = $('[data-mode-note]', f);
    var badge = $('[data-slider-off]', f);
    var btn = $('[data-submit]', f), btnText = $('[data-total]', f), variantInput = $('[name="id"]', f);
    if (!qty || !real) return;
    var minQty = parseInt(qty.min, 10) || 1, maxQty = parseInt(qty.max, 10) || 20;
    var set = function (sel, text) { $$(sel, f).forEach(function (el) { el.textContent = text; }); };

    /* ---- smooth slider: the handle glides freely while dragging, then settles on a whole pack ---- */
    var lo = minQty, hi = maxQty, dragging = false, anim = null, lastBadge = null;
    if (range) {
      range.step = 'any';
      lo = parseFloat(range.min) || minQty; hi = parseFloat(range.max) || maxQty;
    }
    function paint(v) { if (range) range.style.setProperty('--pct', ((v - lo) * 100 / Math.max(1, hi - lo)) + '%'); }
    function glideTo(n) {
      if (!range) return;
      if (anim) { cancelAnimationFrame(anim); anim = null; }
      var from = parseFloat(range.value);
      if (isNaN(from) || reduceMotion || Math.abs(from - n) < 0.001) { range.value = n; paint(n); return; }
      var start = null, dur = Math.min(320, 140 + Math.abs(n - from) * 12);
      function frame(t) {
        if (start === null) start = t;
        var k = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - k, 3), v = from + (n - from) * e;
        range.value = v; paint(v);
        anim = k < 1 ? requestAnimationFrame(frame) : null;
      }
      anim = requestAnimationFrame(frame);
    }

    function mode() { var r = $('[name="sc_purchase"]:checked', f); return r ? r.value : 'one-time'; }
    function cadence() { var r = $('[name="sc_cadence"]:checked', f); return r ? r.value : '2w'; }
    function count() { return Math.min(maxQty, Math.max(minQty, Math.round(parseFloat(qty.value)) || 0)); }
    function conflict() {
      if (!isOffer || cartMode === 'none' || cartPacks === 0) return false;
      if (cartMode === 'mixed') return true;
      if (mode() === 'one-time') return cartMode !== 'one-time';
      return cartMode !== 'subscription' || cartCad !== cadence();
    }

    function update() {
      var list = parseInt(f.dataset.list, 10) || 0;
      var n = count(), m = mode(), c = cadence(), line = list * n, total = cartPacks + n;
      var tier = isOffer ? tierPct(total) : 0;
      var onePay = off(line, tier), subPay = off(list, OFFER.subFirst) * n, renew = off(list, OFFER.sub[c] || 0) * n;
      var pay = m === 'subscription' ? subPay : onePay;
      var pct = m === 'subscription' ? OFFER.subFirst : tier;
      real.value = n;
      if (document.activeElement !== qty) qty.value = n;
      set('[data-price-one]', money(onePay));
      set('[data-price-sub]', money(subPay));
      set('[data-sub-first]', money(subPay));
      set('[data-sub-renew]', money(renew));
      set('[data-sub-renew-pct]', (OFFER.sub[c] || 0) + '% off');
      set('[data-sub-cad]', cadenceLabel(c));
      if (btnText) btnText.textContent = money(pay);
      if (btn && btnText && btn.firstChild && btn.firstChild.nodeType === 3) btn.firstChild.nodeValue = m === 'subscription' ? 'subscribe · ' : 'add to cart · ';

      if (range) {
        if (!dragging) glideTo(n);
        range.setAttribute('aria-valuenow', n);
        range.setAttribute('aria-valuetext', n + ' six-packs, ' + (pct > 0 ? pct + '% off' : 'full price'));
      }
      if (isOffer) {
        set('[data-slider-packs]', n + ' six-pack' + (n > 1 ? 's' : '') + ' · ' + n * 6 + ' cans');
        var badgeText = m === 'subscription' ? OFFER.subFirst + '% off first box' : (pct > 0 ? pct + '% off' : 'full price');
        if (badge) {
          badge.textContent = badgeText;
          if (lastBadge !== null && lastBadge !== badgeText && !reduceMotion) {
            badge.classList.remove('is-bump'); void badge.offsetWidth; badge.classList.add('is-bump');
          }
          lastBadge = badgeText;
        }
        var save = [money(pay) + ' total', money(pay / (n * 6)) + '/can'];
        if (line > pay) save.push('you save ' + money(line - pay));
        if (m === 'one-time' && cartPacks > 0 && !conflict()) save.push('counts the ' + cartPacks + ' already in your cart');
        set('[data-slider-save]', save.join(' · '));
        if (hint) hint.hidden = m === 'subscription';
      }
      if (prop) { prop.disabled = m !== 'subscription'; prop.value = c; }
      if (subBox) subBox.hidden = m !== 'subscription';
      if (note) {
        var show = conflict();
        note.hidden = !show;
        if (show) {
          note.textContent = m === 'subscription'
            ? 'heads up: a cart is one-time or subscription, not both. adding this moves everything in your cart to subscribe & save, ' + cadenceLabel(c) + '.'
            : 'heads up: a cart is one-time or subscription, not both. adding this switches everything in your cart to a one-time order.';
        }
      }
    }

    if (range) {
      range.addEventListener('pointerdown', function () {
        dragging = true;
        if (anim) { cancelAnimationFrame(anim); anim = null; }
      });
      range.addEventListener('input', function () {
        var v = parseFloat(range.value);
        paint(v); /* the fill follows the finger exactly */
        var n = Math.min(maxQty, Math.max(minQty, Math.round(v)));
        if (n !== count() || String(n) !== qty.value) { qty.value = n; update(); }
      });
      var release = function () { if (!dragging) return; dragging = false; glideTo(count()); };
      range.addEventListener('change', release);
      window.addEventListener('pointerup', release);
      window.addEventListener('pointercancel', release);
      range.addEventListener('keydown', function (e) {
        var steps = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1, PageUp: 3, PageDown: -3 }, n = count();
        if (e.key in steps) n += steps[e.key];
        else if (e.key === 'Home') n = minQty;
        else if (e.key === 'End') n = maxQty;
        else return;
        e.preventDefault();
        qty.value = Math.min(maxQty, Math.max(minQty, n));
        update();
      });
    }
    f.addEventListener('change', function (e) { if (e.target !== range) update(); });
    qty.addEventListener('input', update);
    qty.addEventListener('blur', update);
    f.addEventListener('submit', function (e) {
      var n = count();
      qty.value = n; real.value = n;
      if (!conflict()) return;
      e.preventDefault();
      if (btn) btn.disabled = true;
      var m = mode(), c = cadence();
      var extra = [{ id: parseInt(variantInput.value, 10), quantity: n, properties: m === 'subscription' ? { _subscription: c } : {} }];
      window.SaucySwitchCart(m, c, extra)
        .then(function () { window.location.href = base + 'cart'; })
        .catch(function () { if (btn) btn.disabled = false; window.location.reload(); });
    });
    if (range) { range.value = count(); paint(count()); }
    update();
  });
})();